// theme.js
export const lightTheme = {
  fontSize: '14px',
  fontFamily: "'Roboto', sans-serif",
  primary: {
    main: '#FF6B35',
    light: '#FFB199',
  },
  body: '#f9fafb',
  text: '#242424',
  disabled: '#999999',
  success: '#3CE800',
  error: '#E30000',
  info: '#007CFF',
  white: '#FFFFFF',
  blue: {
    50: '#F2F5FF',
    100: '#E4EBFE',
    200: '#D7E2FE',
    300: '#CAD8FE',
    400: '#BCCEFD',
    500: '#AFC4FD',
    600: '#A2BAFD',
    700: '#95B1FD',
    800: '#87A7FC',
    900: '#7A9DFC',
  },
  gray: {
    50: '#E9E9E9',
    100: '#D3D3D3',
    200: '#BDBDBD',
    300: '#A7A7A7',
    400: '#919191',
    500: '#7C7C7C',
    600: '#666666',
    700: '#505050',
    800: '#3A3A3A',
    900: '#242424',
  },
  typography: {
    title: {
      large: '20px',
      medium: '16px',
      small: '14px',
    },
    header: {
      medium: '16px',
      small: '14px',
    },
    medium: {
      large: '16px',
      small: '14px',
    },
    description: {
      large: '16px',
      medium: '14px',
      small: '12px',
      xsmall: '10px',
    },
  },
};

export const darkTheme = {
  body: '#121212', // Dark background
  text: '#FFFFFF', // White text
  primaryColor: '#1E3A8A', // Darker Blue
  secondaryColor: '#FF4A4A', // Darker Red
  successColor: '#4CAF50', // Darker Green success
  surface: '#1C1C1C', // Dark surface for containers
  neutralDark: '#171717', // Dark gray for darker elements
  neutralLight: '#424242', // Gray for borders, backgrounds
  fontSize: '16px',
  fontFamily: "'Roboto', sans-serif",
  typography: {
    title: {
      large: '20px',
      medium: '16px',
      small: '14px',
    },
    header: {
      medium: '16px',
      small: '14px',
    },
    medium: {
      large: '16px',
      small: '14px',
    },
    description: {
      large: '16px',
      medium: '14px',
      small: '12px',
      xsmall: '10px',
    },
  },
};
